import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { useNav } from "../hooks/useNav.js";
import { resolveItemUrl, isExternalLink } from "../utils/navUrl.js";
import "./NavTopSubMenu.css";

const PERMISSION_STATE = {
  canSeeReports: false,
};

const NavTopSubMenu = ({ logout }) => {
  const { nav } = useNav();
  const [canSeeReports, setCanSeeReports] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const fetchPermissions = async () => {
      var cached = localStorage.getItem("canSeeReports");
      const cachedExpDate = localStorage.getItem("canSeeReportsExpiration");
      const cachedExpToken = localStorage.getItem("canSeeReportsToken");

      try {
        let idToken = document.cookie
          .split("; ")
          .find((row) => row.startsWith("msal.44facb45-e540-41a9-8ff3-ebb6b6bf5498.idtoken"))
          ?.split("=")[1];
        if (!idToken) {
          let authAccount = localStorage.getItem("authAccount");
          if (authAccount) {
            authAccount = JSON.parse(authAccount);
            idToken = authAccount.idToken;
          }
        }

        const now = new Date();
        let needToCheck = false;

        if (cachedExpDate) {
          const expirationDate = new Date(cachedExpDate);
          if (isNaN(expirationDate) || now > expirationDate) {
            localStorage.removeItem("canSeeReports");
            localStorage.removeItem("canSeeReportsExpiration");
            localStorage.removeItem("canSeeReportsToken");
            needToCheck = true;
          }
        }
        if (cachedExpToken && cachedExpToken !== idToken) {
          localStorage.removeItem("canSeeReports");
          localStorage.removeItem("canSeeReportsExpiration");
          localStorage.removeItem("canSeeReportsToken");
          needToCheck = true;
          cached = "bypass";
        }
        if (cached === "true") {
          setCanSeeReports(true);
          if (!needToCheck) return;
        }
        if (cached === "false") {
          setCanSeeReports(false);
          if (!needToCheck) return;
        }

        const expiration = new Date();
        expiration.setHours(expiration.getHours() + 1);

        await axios
          .get(
            "https://seiu-mrc.azurewebsites.net/api/CanUserSeeReport?code=mFudbFqK94yVyY9NW0LHUZIdT4wdbYgNRAXNdxgIzm9CAzFubwr11w==",
            { headers: { SendAuthorization: "Bearer " + idToken } }
          )
          .then(() => {
            setCanSeeReports(true);
            localStorage.setItem("canSeeReports", "true");
            localStorage.setItem("canSeeReportsExpiration", expiration);
            localStorage.setItem("canSeeReportsToken", idToken);
          })
          .catch((catchResponse) => {
            setCanSeeReports(false);
            localStorage.setItem("canSeeReports", "false");
            localStorage.setItem("canSeeReportsExpiration", expiration);
            localStorage.setItem("canSeeReportsToken", idToken);
            if (catchResponse?.response?.data?.canViewMRC == "false") {
              logout();
            }
          });
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };

    fetchPermissions();
  }, []);

  PERMISSION_STATE.canSeeReports = canSeeReports;

  const collapse = () => setExpanded(false);

  const handleLogout = () => {
    logout();
    collapse();
  };

  const itemVisible = (item) => {
    if (!item.requiresPermission) return true;
    return PERMISSION_STATE[item.requiresPermission] === true;
  };

  const renderItemLink = (item, className) => {
    const url = resolveItemUrl(item);
    const external = isExternalLink(item);
    return (
      <Nav.Link
        href={url}
        target={external ? "_blank" : undefined}
        rel={external ? "noreferrer" : undefined}
        onClick={collapse}
        className={className}
      >
        {item.title}
      </Nav.Link>
    );
  };

  const renderDropdownItem = (item) => {
    const url = resolveItemUrl(item);
    const external = isExternalLink(item);
    return (
      <NavDropdown.Item
        key={`${item.type}:${item.title}`}
        href={url}
        target={external ? "_blank" : undefined}
        rel={external ? "noreferrer" : undefined}
        onClick={collapse}
        className="dropdown-item nav-item-font"
      >
        {item.title}
      </NavDropdown.Item>
    );
  };

  const sortedCategories = [...(nav?.categories || [])].sort(
    (a, b) => (a.position ?? 0) - (b.position ?? 0)
  );

  return (
    <Navbar expand="lg" expanded={expanded} onToggle={setExpanded} className="subnav-container">
      <Container>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded((prev) => !prev)}
          className="navbar-toggler"
        />
        <Navbar.Collapse id="basic-navbar-nav" className="navbar-collapse">
          <Nav className="subnav-links flex-container">
            {sortedCategories.map((category) => {
              const visibleItems = category.items.filter(itemVisible);
              if (visibleItems.length === 0) return null;

              if (category.position === 1) {
                return visibleItems.map((item) => (
                  <Nav.Item key={`${category.title}:${item.title}`} className="nav-item">
                    {renderItemLink(item, "nav-link nav-item-font")}
                  </Nav.Item>
                ));
              }

              return (
                <NavDropdown
                  key={category.title}
                  title={category.title}
                  id={`${category.title.toLowerCase().replace(/\s+/g, "-")}-dropdown`}
                  className="dropdown nav-item-font"
                >
                  {visibleItems.map(renderDropdownItem)}
                </NavDropdown>
              );
            })}

            <Nav.Item className="nav-item">
              <Nav.Link href="#" onClick={handleLogout} className="nav-link nav-item-font">
                Logout
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavTopSubMenu;
